<template>
  <div class="flex items-center gap-3 min-w-0 w-full">
    <div :class="[avatarSizeClass, shapeClass, 'relative flex-shrink-0 overflow-hidden']">
      <img
        v-if="!imgError && displayAvatar"
        :src="displayAvatar"
        :alt="title"
        :class="[avatarSizeClass, shapeClass, 'object-cover']"
        @error="onImgError"
      />
      <div
        v-else
        :class="[avatarSizeClass, shapeClass, 'bg-blue-100 text-blue-600 flex items-center justify-center font-medium text-sm']"
      >
        {{ initials }}
      </div>
    </div>

    <div class="flex-1 min-w-0">
      <div class="font-medium text-gray-900 truncate">{{ title }}</div>
      <div v-if="subtitle" class="text-xs text-gray-500 truncate">{{ subtitle }}</div>
    </div>

    <div class="flex items-center gap-2">
      <slot name="right" />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const DEFAULT_AVATAR_URL = 'https://cdn-icons-png.flaticon.com/128/3177/3177440.png'

const props = defineProps({
  avatarUrl: { type: String, default: '' },
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  // Размер аватара: md (40px) | lg (48px)
  size: { type: String, default: 'md' },
  // Форма аватара
  shape: { type: String, default: 'rounded-full' }
})

const imgError = ref(false)
const onImgError = () => { imgError.value = true }

const avatarSizeClass = computed(() => props.size === 'md' ? 'w-10 h-10' : 'w-12 h-12')
const shapeClass = computed(() => props.shape)

const displayAvatar = computed(() => props.avatarUrl || DEFAULT_AVATAR_URL)

const initials = computed(() => {
  const parts = (props.title || '').trim().split(/\s+/)
  const a = parts[0]?.[0] || ''
  const b = parts[1]?.[0] || ''
  return (a + b).toUpperCase() || 'U'
})
</script>
